export default __webpack_public_path__ + "static/media/search-icon.ddb963b1.svg";